'use strict';
import moment from 'moment-timezone';
angular.module('docketbook').
  service('jobService', function (orderService, $http, $stateParams, $cookies, $q, $timeout, Restangular, geolocation, accessControl) {

    /***** Save a job ******/
    var saveJob = function (job, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var job = angular.copy(job);
      var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');
      if (job.orderRef != null) {
        // extract customer information from order and append to job
        if (job.orderRef.customer) {
          job.customer = job.orderRef.customer;
        }
        if (job.orderRef.customerGroup) {
          job.customerGroup = job.orderRef.customerGroup;
        }
        if (job.orderRef.customerName) {
          job.customerName = job.orderRef.customerName;
        }
        if (job.orderRef.customerAddress) {
          job.customerAddress = job.orderRef.customerAddress;
        }
        if (job.orderRef.id != null) {
          job.orderRef = job.orderRef.id;
        }
      } else {
        delete job.orderRef;
      }

      // convert js dates to ISO date strings
      if (job.startDate) {
        job.startDate = moment(job.startDate).format('YYYY-MM-DD');
      }
      if (job.endDate) {
        job.endDate = moment(job.endDate).format('YYYY-MM-DD');
      }

      // update line items to have id's for ref'd items - not objects
      if (job.lineItems != null) {
        for (var i = 0; i < job.lineItems.length; i++) {
          // save quantities in minutes
          if (job.lineItems[i].resource && job.lineItems[i].resource.uom) {
            if (job.lineItems[i].resource.uom.isTime) {
              var totalMinutes = 0;
              if (job.lineItems[i].quantityHoursEdit) {
                totalMinutes += parseInt(job.lineItems[i].quantityHoursEdit) * 60;
              }
              if (job.lineItems[i].quantityMinutesEdit) {
                totalMinutes += parseInt(job.lineItems[i].quantityMinutesEdit);
              }
              job.lineItems[i].quantity = totalMinutes;

            } else {
              job.lineItems[i].quantity = parseFloat(job.lineItems[i].quantityEdit);
            }
          }

          if (job.lineItems[i].resource && job.lineItems[i].resource.id != null) {
            job.lineItems[i].resource = job.lineItems[i].resource.id;
          }
        }
      }

      // update job assignee status's
      if (job.assignees != null) {
        for (var i = 0; i < job.assignees.length; i++) {
          job.assignees[i].status = job.assignees[i].status.toLowerCase();
        }
      }

      if (job.status) {
        job.status = job.status.toLowerCase();
      }

      if (job.id == null) {
        // new job - save new
        var currentOrg = organisation;
        var currentOrgGroup = organisationGroup;
        job.jobOwner = currentOrg.id;
        job.status = 'draft';
        if (currentOrgGroup != null) {
          job.organisationGroup = currentOrgGroup.id;
        }
        job.jobNumber = null;
        baseJobs.post(job).then(successCb, failureCb);
      } else {
        baseJobs.one(job.id).customPUT(job).then(successCb, failureCb);
      }
    }

    this.saveJob = saveJob;

    /********** Get Single Job *************/
    var getJob = function (jobId, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var currentUser = accessControl.currentUser();

      var baseJobs = Restangular.all('jobs');
      if (organisation != null) {
        baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');
      }

      if (jobId.id != null) {
        jobId = jobId.id;
      }
      baseJobs.one(jobId).get().then(function (fullJob) {
        fullJob.status = fullJob.status.charAt(0).toUpperCase() + fullJob.status.slice(1);
        if (fullJob.lineItems == null) {
          fullJob.lineItems = [];
        }
        // prepare dates correctly
        if (fullJob.startDate) {
          fullJob.startDate = moment(fullJob.startDate).toDate();
        }
        if (fullJob.endDate) {
          fullJob.endDate = moment(fullJob.endDate).toDate();
        }
        fullJob.statusDisplay = fullJob.status;
        // check if currentUser is an assignee
        for (var i = 0; i < fullJob.assignees.length; i++) {
          fullJob.assignees[i].status = fullJob.assignees[i].status.charAt(0).toUpperCase() + fullJob.assignees[i].status.toLowerCase().slice(1);
          if (fullJob.assignees[i].assignee == currentUser.id) {
            fullJob.userIsAssignee = true;
            fullJob.userAssigneeData = fullJob.assignees[i];
            if (!accessControl.userHasPermission('io.docketbook.ojdapi.updateJob')) {
              fullJob.statusDisplay = fullJob.userAssigneeData.status.charAt(0).toUpperCase() + fullJob.userAssigneeData.status.slice(1);
            }
          }
        }
        // sort job comments by date
        fullJob.comments.sort(function (a, b) {
          return moment(b.date, moment.ISO_8601).toDate() - moment(a.date, moment.ISO_8601).toDate();
        });
        // make sure job comments are using html line breaks
        for (var i = 0; i < fullJob.comments.length; i++) {
          if (fullJob.comments[i].comment != '') {
            fullJob.comments[i].comment = fullJob.comments[i].comment.replace(/\r?\n/g, '<br/>');
          }
        }
        // fix dockets status's
        for (var i = 0; i < fullJob.dockets.length; i++) {
          fullJob.dockets[i].status = fullJob.dockets[i].status.charAt(0).toUpperCase() + fullJob.dockets[i].status.slice(1);
        }

        // Populate the query params for lookup

        let params = {
          orgs: [],
          groups: [],
          users: []
        }

        let lookupToDo = false;

        fullJob.assignees.forEach((a) => {
          if (params.orgs.indexOf(a.organisation) === -1) {
            params.orgs.push(a.organisation)
            lookupToDo = true;
          }
          if (params.groups.indexOf(a.organisationGroup) === -1) {
            params.groups.push(a.organisationGroup)
            lookupToDo = true;
          }
          if (params.users.indexOf(a.assignee) === -1) {
            params.users.push(a.assignee)
            lookupToDo = true;
          }
        })

        let lookupPromise = Promise.resolve({
          organisations: [],
          organisationGroups: [],
          users: []
        })
        if (lookupToDo) {
          lookupPromise = Restangular.all('lookup').customGET('', { organisations: params.orgs.join(','), organisationGroups: params.groups.join(',') });
        }

        // successCb(fullJob);
        return Promise.all([
          fullJob,
          lookupPromise
        ]);
      }).then((response) => {
        var fullJob = response[0]
        var lookups = response[1]

        // convert the response into an object of objects for quick lookup

        lookups.organisations = lookups.organisations.reduce((acc, value) => {
          acc[value.id] = value
          return acc;
        }, {})

        lookups.organisationGroups = lookups.organisationGroups.reduce((acc, value) => {
          acc[value.id] = value
          return acc;
        }, {})

        fullJob.assignees = fullJob.assignees.map((assignee) => {
          // get company name
          let orgName = "";
          if (lookups.organisations[assignee.organisation]) {
            orgName = lookups.organisations[assignee.organisation].name;
          }

          let groupName = "";
          if (lookups.organisationGroups[assignee.organisationGroup]) {
            groupName = lookups.organisationGroups[assignee.organisationGroup].name;
          }

          let name = `${orgName} - ${groupName}`;
          if (orgName === groupName) {
            name = `${orgName}`
          }
          assignee.company = name;
          return assignee
        });

        return successCb(fullJob);
      }).catch(failureCb);
    }

    this.getJob = getJob;

    /************ Send a Job ************/
    var sendJob = function (job, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');

      var jobObject = {};
      jobObject.status = "sent";

      var jobId = job;
      if (jobId.id != null) {
        jobId = jobId.id;
      }

      baseJobs.one(jobId).customPUT(jobObject).then(successCb, failureCb);
    }

    this.sendJob = sendJob;

    /***** Send Bulk Jobs *****/
    this.sendBulkJobs = function (jobs, successCb) {
      var failures = [];
      sendJobs(jobs, 0, failures, function (failuresFilled) {
        successCb(failuresFilled);
      });
    }

    var sendJobs = function (list, index, failures, successCb) {
      if (index >= list.length) {
        successCb(failures);
        return;
      }

      sendJob(list[index].id, function (success) {
        sendJobs(list, index + 1, failures, successCb);
      }, function (err) {
        failures.push(list[index]);
        sendJobs(list, index + 1, failures, successCb);
      });
    }

    /*********** Close a Job *************/
    var closeJob = function (job, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var jobObject = { status: "closed" };
      var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');

      var jobId = job;
      if (jobId.id != null) {
        jobId = jobId.id;
      }

      baseJobs.one(jobId).customPUT(jobObject).then(successCb, failureCb);
    }

    this.closeJob = closeJob;

    /***** Close Bulk Jobs ******/
    this.closeBulkJobs = function (jobs, successCb) {
      var failures = [];
      closeJobs(jobs, 0, failures, function (failuresFilled) {
        successCb(failuresFilled);
      });
    }

    var closeJobs = function (list, index, failures, successCb) {
      if (index >= list.length) {
        successCb(failures);
        return;
      }

      closeJob(list[index].id, function (success) {
        closeJobs(list, index + 1, failures, successCb);
      }, function (err) {
        failures.push(list[index]);
        closeJobs(list, index + 1, failures, successCb);
      });
    }

    /**** Delete a job ****/
    var deleteJob = function (job, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');
      var jobId = angular.copy(job);
      if (jobId.id != null) {
        jobId = jobId.id;
      }
      baseJobs.one(jobId).remove().then(successCb, failureCb);
    }

    this.deleteJob = deleteJob;

    /**** Delete Bulk Jobs ****/
    this.deleteBulkJobs = function (jobs, successCb) {
      var failures = [];
      deleteJobs(jobs, 0, failures, function (failuresFilled) {
        successCb(failuresFilled);
      });
    }

    var deleteJobs = function (list, index, failures, successCb) {
      if (index >= list.length) {
        successCb(failures);
        return;
      }

      deleteJob(list[index].id, function (success) {
        deleteJobs(list, index + 1, failures, successCb);
      }, function (err) {
        failures.push(list[index]);
        deleteJobs(list, index + 1, failures, successCb);
      });
    }

    /***** Update Job Access Control Object *****/
    this.updateAccessControl = function (job, accessControlPayload, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseJobs = Restangular.all('jobs');
      if (organisation != null && organisationGroup != null) {
        baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');
      }

      var jobId = job;
      if (jobId.id != null) {
        jobId = jobId.id;
      }

      var accessControlFull = { 'accessControl': accessControlPayload };
      baseJobs.one(jobId).customPUT(accessControlFull).then(successCb, failureCb);
    }

    /**** Assignee status change ****/
    this.assigneeStatusChange = function (job, assignee, statusTo, rejectReason, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var organisationId = null;
      var organisationGroupId = null;

      if (organisation == null || organisation == undefined) {
        organisationId = job.organisation;
      } else {
        organisationId = organisation.id;
      }
      if (organisationGroup == null || organisationGroup == undefined) {
        organisationGroupId = job.organisationGroup;
      } else {
        organisationGroupId = organisationGroup.id;
      }

      var baseJobs = Restangular.all('organisations').one(organisationId).all('groups').one(organisationGroupId).all('jobs');
      var job = angular.copy(job);

      var postObj = {};
      postObj.assignee = assignee;
      postObj.status = statusTo.toLowerCase();
      if (rejectReason) {
        postObj.rejectionComment = rejectReason;
      }

      baseJobs.one(job.id).all('assignee').customPUT(postObj).then(function (success) {
        successCb();
      }, failureCb);
    }

    /******* Add Assignee(s) to job ********/
    this.addAssignee = function (job, people, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');

      // get current job
      baseJobs.one(job.id).get().then(function (fullJob) {
        var currentAssignees = fullJob.assignees;

        for (var i = 0; i < people.length; i++) {
          // make sure this person is not already assigned
          var found = false;
          for (var j = 0; j < currentAssignees.length; j++) {
            if (currentAssignees[j].assignee == people[i].id) {
              found = true;
              break;
            }
          }
          if (!found) {
            var newAssignee = {};
            newAssignee.assignee = people[i].id;
            newAssignee.name = people[i].name.full;
            newAssignee.status = "assigned";
            currentAssignees.push(newAssignee);
          }
        }

        var putObj = { 'assignees': currentAssignees };
        baseJobs.one(job.id).customPUT(putObj).then(successCb, failureCb);
      }, function (err) {
        failureCb(err);
      });
    }

    /******* Remove Assignee from job *******/
    this.removeAssignee = function (job, assignee, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');

      // get current job
      baseJobs.one(job.id).get().then(function (fullJob) {
        var currentAssignees = fullJob.assignees;
        for (var i = 0; i < currentAssignees.length; i++) {
          if (currentAssignees[i].id == assignee.id) {
            currentAssignees[i].delete = true;
          }
        }

        var putObj = { 'assignees': currentAssignees };
        baseJobs.one(job.id).customPUT(putObj).then(successCb, failureCb);
      }, function (err) {
        failureCb(err);
      });
    }

    this.removeAssignees = function (job, assignees, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');

      // get current job
      baseJobs.one(job.id).get().then(function (fullJob) {
        var currentAssignees = fullJob.assignees;
        for (var i = 0; i < currentAssignees.length; i++) {
          if (assignees.map(a => a.id).includes(currentAssignees[i].id)) {
            currentAssignees[i].delete = true;
          }
        }

        var putObj = { 'assignees': currentAssignees };
        baseJobs.one(job.id).customPUT(putObj).then(successCb, failureCb);
      }, function (err) {
        failureCb(err);
      });
    }

    /******* Assginee Comment ********/
    this.addAssigneeComment = function (job, commentText, successCb, failureCb) {
      var postObj = {};
      postObj.assignee = job.userAssigneeData.assignee;
      postObj.comment = {};
      postObj.comment.comment = commentText;
      postObj.comment.date = moment().toISOString();

      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseJobs = "";

      if (organisation == null || organisationGroup == null) {
        baseJobs = Restangular.all('organisations').one(job.organisation).all('groups').one(job.organisationGroup).all('jobs');
      } else {
        baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');
      }

      baseJobs.one(job.id).all('assignee').customPUT(postObj).then(successCb, failureCb);
    }

    /******* Delete Assginee Comment *******/
    this.deleteAssigneeComment = function (job, comment, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');

      var postObj = {};
      postObj.assignee = job.userAssigneeData.assignee;
      postObj.comment = {};
      postObj.comment.id = comment.id;
      postObj.comment.delete = true;
      baseJobs.one(job.id).all('assignee').customPUT(postObj).then(successCb, failureCb);
    }

    /******* Add editor comment to job *******/
    this.addComment = function (job, comment, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');

      baseJobs.one(job.id).get().then(function (fullJob) {
        if (fullJob.comments == null) {
          fullJob.comments = [];
        }

        job.comments.splice(0, 0, comment);
        var putObj = { 'comments': job.comments };
        baseJobs.one(job.id).customPUT(putObj).then(successCb, failureCb);
      }, failureCb);
    }

    /******* Delete Comment From Job ********/
    this.deleteComment = function (job, comment, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');

      baseJobs.one(job.id).get().then(function (fullJob) {
        for (var i = 0; i < fullJob.comments.length; i++) {
          if (fullJob.comments[i].id == comment.id) {
            fullJob.comments[i].delete = true;
            break;
          }
        }

        var putObj = { 'comments': fullJob.comments };
        baseJobs.one(job.id).customPUT(putObj).then(successCb, failureCb);
      }, failureCb);
    }

    /******* Get list of jobs ********/
    this.getJobs = function (params, successCb, failureCb) {
      if (params == null) {
        params = {};
      }

      /**** Setup scope - group or myDocketbook ****/
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseJobs = null;

      if (organisationGroup != null) {
        baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');
      } else {
        baseJobs = Restangular.all('jobs');
      }
      /**** End scope setup ****/

      if (params['status'] != null) {
        params['status'] = params['status'].toLowerCase();
      }
      if (params['offset'] != null && params['limit'] != null) {
        baseJobs.customGET("", params).then(successCb, failureCb);
      } else {
        baseJobs.getList(params).then(successCb, failureCb);
      }
    }

    /******** Populate Job Detail ********/
    this.populateJobDetails = function (jobsList, cb) {
      populateDetailOnJobs(jobsList, 0, cb);
    }

    var populateDetailOnJobs = function (jobsList, index, cb) {
      if (index >= jobsList.length) {
        cb(jobsList);
        return;
      }

      getJob(jobsList[index].id, function (jobDetail) {
        jobsList[index] = jobDetail;
        populateDetailOnJobs(jobsList, index + 1, cb);
      }, function (err) {
        populateDetailOnJobs(jobsList, index + 1, cb);
      });
    }

    /******** Parse Jobs **********/
    var parseJobs = function (data) {
      var currentUser = accessControl.currentUser();
      var jobs = [];
      data.forEach(function (job) {
        job.loading = false;
        job.status = job.status.charAt(0).toUpperCase() + job.status.slice(1);
        job.statusDisplay = job.status;
        // get summary data on assignee status'
        job.assignedCount = 0;
        job.acceptedCount = 0;
        job.rejectedCount = 0;
        job.completedCount = 0;
        job.assignedUsers = [];
        job.acceptedUsers = [];
        job.rejectedUsers = [];
        job.completedUsers = [];
        job.selected = false;
        for (var i = 0; i < job.assignees.length; i++) {
          job.assignees[i].status = job.assignees[i].status.charAt(0).toUpperCase() + job.assignees[i].status.toLowerCase().slice(1);
          // check if user is an assignee on job
          if (job.assignees[i].assignee == currentUser.id) {
            job.userAssigneeData = job.assignees[i];
            job.statusDisplay = job.userAssigneeData.status.charAt(0).toUpperCase() + job.userAssigneeData.status.slice(1);
          }
          if (job.assignees[i].status.toLowerCase() == 'assigned') {
            job.assignedCount += 1;
            job.assignedUsers.push(job.assignees[i]);
          }
          if (job.assignees[i].status.toLowerCase() == 'accepted') {
            job.acceptedCount += 1;
            job.acceptedUsers.push(job.assignees[i]);
          }
          if (job.assignees[i].status.toLowerCase() == 'rejected') {
            job.rejectedCount += 1;
            job.rejectedUsers.push(job.assignees[i]);
          }
          if (job.assignees[i].status.toLowerCase() == 'completed') {
            job.completedCount += 1;
            job.completedUsers.push(job.assignees[i]);
          }
        }
        jobs.push(job);
      });

      return jobs;
    }

    this.parseJobs = parseJobs;

    /******* Get New Docket From Job *******/
    this.createDocketFromJob = function (job, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');

      var jobId = job;
      if (jobId.id != null) {
        jobId = jobId.id;
      }

      baseJobs.one(jobId).post().then(successCb, failureCb);
    }

    /******* Get job diff ********/
    this.getJobDiff = function (original, modified, cb) {
      // check start/end date fields
      if (modified.id == null) {
        cb(modified, 1);
        return;
      }
      var diff = {};
      var diffCount = 0;
      if (!original.startDate && modified.startDate) {
        diff.startDate = modified.startDate;
        diffCount += 1;
      }
      if (original.startDate && modified.startDate && (original.startDate.getTime() != modified.startDate.getTime())) {
        diff.startDate = modified.startDate;
        diffCount += 1;
      }
      if (!original.endDate && modified.endDate) {
        diff.endDate = modified.endDate;
        diffCount += 1;
      }
      if (original.endDate && modified.endDate && (original.endDate.getTime() != modified.endDate.getTime())) {
        diff.endDate = modified.endDate;
        diffCount += 1;
      }

      // check order ref
      if (!original.orderRef && modified.orderRef) {
        diff.orderRef = modified.orderRef;
        diff.customerContact = modified.customerContact;
        diff.supplierContact = modified.supplierContact;
        diffCount += 1;
      }
      if (original.orderRef && modified.orderRef) {
        if (original.orderRef.id != null && modified.orderRef.id != null && original.orderRef.id != modified.orderRef.id) {
          diff.orderRef = modified.orderRef;
          diff.customerContact = modified.customerContact;
          diff.supplierContact = modified.supplierContact;
          diffCount += 1;
        } else if (original.orderRef.id == null && modified.orderRef.id == null && original.orderRef != modified.orderRef) {
          diff.orderRef = modified.orderRef;
          diff.customerContact = modified.customerContact;
          diff.supplierContact = modified.supplierContact;
          diffCount += 1;
        }
      }
      // check customer contact
      if (!original.customerContact && modified.customerContact) {
        diff.customerContact = modified.customerContact;
        diffCount += 1;
      }
      if (original.customerContact && modified.customerContact && original.customerContact.displayName != modified.customerContact.displayName) {
        diff.customerContact = modified.customerContact;
        diffCount += 1;
      }
      // check supplier contact
      if (!original.supplierContact && modified.supplierContact) {
        diff.supplierContact = modified.supplierContact;
        diffCount += 1;
      }
      if (original.supplierContact && modified.supplierContact && original.supplierContact.displayName != modified.supplierContact.displayName) {
        diff.supplierContact = modified.supplierContact;
        diffCount += 1;
      }
      // check line items
      if (!original.lineItems && modified.lineItems) {
        diff.lineItems = modified.lineItems;
        diffCount += 1;
      }
      if (original.lineItems && modified.lineItems) {
        var linesChanged = false;
        if (original.lineItems.length != modified.lineItems.length) {
          linesChanged = true;
        } else {
          for (var i = 0; i < modified.lineItems.length; i++) {
            if (modified.lineItems[i].delete == true) {
              linesChanged = true;
              break;
            }
            if (modified.lineItems[i].id != original.lineItems[i].id) {
              linesChanged = true;
              break;
            }
            if (modified.lineItems[i].itemDescription != original.lineItems[i].itemDescription) {
              linesChanged = true;
              break;
            }
            if (modified.lineItems[i].resource.id != original.lineItems[i].resource.id) {
              linesChanged = true;
              break;
            }
            if ($stateParams.device == 'desktop') {
              if (original.lineItems[i].quantityEdit != modified.lineItems[i].quantityEdit) {
                linesChanged = true;
                break;
              }
              if (original.lineItems[i].quantityHoursEdit != modified.lineItems[i].quantityHoursEdit) {
                linesChanged = true;
                break;
              }
              if (original.lineItems[i].quantityMinutesEdit != modified.lineItems[i].quantityMinutesEdit) {
                linesChanged = true;
                break;
              }
            } else {
              if (!original.lineItems[i].quantity && modified.lineItems[i].quantity) {
                linesChanged = true;
                break;
              }
              if (modified.lineItems[i].quantity && original.lineItems[i].quantity && modified.lineItems[i].quantity != original.lineItems[i].quantity) {
                linesChanged = true;
                break;
              }
            }
          }
        }
        if (linesChanged) {
          diff.lineItems = modified.lineItems;
          diffCount += 1;
        }
      }

      // check instructions
      if (!original.instructions && modified.instructions) {
        diff.instructions = modified.instructions;
        diffCount += 1;
      }
      if (original.instructions && modified.instructions && original.instructions != modified.instructions) {
        diff.instructions = modified.instructions;
        diffCount += 1;
      }
      // check from and to addresses
      if (!original.fromAddress && modified.fromAddress) {
        diff.fromAddress = modified.fromAddress;
        diffCount += 1;
      }
      if (original.fromAddress && modified.fromAddress && original.fromAddress != modified.fromAddress) {
        diff.fromAddress = modified.fromAddress;
        diffCount += 1;
      }
      if (!original.toAddress && modified.toAddress) {
        diff.toAddress = modified.toAddress;
        diffCount += 1;
      }
      if (original.toAddress && modified.toAddress && original.toAddress != modified.toAddress) {
        diff.toAddress = modified.toAddress;
        diffCount += 1;
      }

      // check assignees array
      /*if ( !original.assignees && modified.assignees ) {
        diff.assignees = modified.assignees;
        diffCount += 1;
      }
      if ( original.assignees && modified.assignees ) {
        var assigneesChanged = false;
        if ( original.assignees.length != modified.assignees.length ) {
          assigneesChanged = true;
        } else {
          for ( var i = 0; i < modified.assignees.length; i++ ) {
            if ( modified.assignees[i].assignee != original.assignees[i].assignee ) {
              assigneesChanged = true;
              break;
            } else if ( modified.assignees[i].delete == true ) {
              assigneesChanged = true;
              break;
            }
          }
        }
        if ( assigneesChanged ) {
          diff.assignees = modified.assignees;
          diffCount += 1;
        }
      }*/

      // check comments array
      /*if ( !original.comments && modified.comments ) {
        diff.comments = modified.comments;
        diffCount += 1;
      }
      if ( original.comments && modified.comments ) {
        var commentsChanged = false;
        if ( original.comments.length != modified.comments.length ) {
          commentsChanged = true;
        } else {
          for ( var i = 0; i < modified.comments.length; i++ ) {
            if ( modified.comments[i].comment != original.comments[i].comment ) {
              commentsChanged = true;
              break;
            } else if ( modified.comments[i].delete == true ) {
              commentsChanged = true;
              break;
            }
          }
        }
        if ( commentsChanged ) {
          diff.comments = modified.comments;
          diffCount += 1;
        }
      }*/

      diff.id = modified.id;
      cb(diff, diffCount);
    }

    /** Validation Parameters **/
    // Lists the required fields for each action on the job and their respective types
    var validationParameters = {
      'sendJob': { 'orderRef': 'string', 'startDate': 'string', 'endDate': 'string', 'lineItems': 'array' },
      'createDocketFromJob': { 'orderRef': 'string' }
    };
    var niceFieldDisplays = {
      'orderRef': 'Order',
      'startDate': 'Start Date',
      'endDate': 'End Date',
      'assignees': 'Assignees',
      'lineItems': 'Items'
    };

    var checkRequiredParameters = function (job, parameters, successCb, failureCb) {
      var exceptions = [];
      var paramsKeys = Object.keys(parameters);
      for (var i = 0; i < paramsKeys.length; i++) {
        var thisParam = paramsKeys[i];
        if (parameters[thisParam] == 'string' && (job[thisParam] == null || job[thisParam] == "")) {
          if (niceFieldDisplays[thisParam] != null) {
            exceptions.push(niceFieldDisplays[thisParam]);
          } else {
            exceptions.push(thisParam);
          }
        } else if (parameters[thisParam] == 'array' && (job[thisParam] == null || job[thisParam].length <= 0)) {
          if (niceFieldDisplays[thisParam] != null) {
            exceptions.push(niceFieldDisplays[thisParam]);
          } else {
            exceptions.push(thisParam);
          }
        }
      }

      if (exceptions.length > 0) {
        failureCb(exceptions);
      } else {
        successCb();
      }
    }

    /* Send Job Validation Helper */
    this.validateSendJob = function (job, successCb, failureCb) {
      var validateParams = validationParameters['sendJob'];
      checkRequiredParameters(job, validateParams, successCb, failureCb);
    }

    /* Create Docket From Job Validation Helper */
    this.validateCreateDocket = function (job, successCb, failureCb) {
      var validateParams = validationParameters['createDocketFromJob'];
      checkRequiredParameters(job, validateParams, successCb, failureCb);
    }
  });



// WEBPACK FOOTER //
// ./src/services/jobService.js